import React from 'react';
import { Link } from 'react-router-dom';
import {
  CheckCircleIcon,
  DocumentTextIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';
import TimelyzerLogo from '../brand/TimelyzerLogo';

const AuthShell = ({ children, eyebrow, title, description }) => (
  <div className="min-h-screen bg-[#f4f6f3]">
    <div className="grid min-h-screen lg:grid-cols-[minmax(420px,.9fr)_minmax(520px,1.1fr)]">
      <aside className="relative hidden overflow-hidden border-r border-[#dce3dd] bg-[#17211c] p-10 text-white lg:flex lg:flex-col">
        <Link to="/" className="flex items-center gap-3">
          <TimelyzerLogo inverse markClassName="h-10 w-10" />
        </Link>

        <div className="my-auto max-w-md">
          <p className="text-xs font-bold uppercase text-[#9bc8b2]">One assistant. Your whole life.</p>
          <h2 className="mt-4 text-4xl font-bold leading-tight">
            A little less to keep in mind.
          </h2>
          <p className="mt-5 text-base leading-7 text-[#bdc8c1]">
            Bring your work, plans and everyday life together. Talk to your assistant and open the workspace you need alongside the conversation.
          </p>

          <div className="mt-10 space-y-3">
            {[
              [DocumentTextIcon, 'Capture without choosing an app'],
              [SparklesIcon, 'See what needs attention now'],
              [CheckCircleIcon, 'Review decisions and keep moving'],
            ].map(([Icon, label]) => (
              <div key={label} className="flex items-center gap-3 border-t border-white/10 py-3">
                <Icon className="h-5 w-5 text-[#9bc8b2]" />
                <span className="text-sm font-semibold text-[#e3e9e5]">{label}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs leading-5 text-[#87958c]">Your priorities, connected in one place.</p>
      </aside>

      <main className="flex min-h-screen items-center justify-center px-5 py-10 sm:px-8">
        <div className="w-full max-w-md">
          <Link to="/" className="mb-10 flex items-center gap-3 lg:hidden">
            <TimelyzerLogo />
          </Link>

          <div className="eyebrow">{eyebrow}</div>
          <h1 className="text-3xl font-bold leading-tight text-[#17211c]">{title}</h1>
          <p className="mt-3 text-sm leading-6 text-[#65716a]">{description}</p>

          <div className="mt-8">{children}</div>
        </div>
      </main>
    </div>
  </div>
);

export default AuthShell;
